export const makeUserAdmin = async (userID, setMakeUserAdminStatusMessage) => {
  try {
    const response = await fetch(
      "https://wad-backend.ws381566.remote.ac/makeAdmin.php?adminRequired=true&userID=" + userID,
      {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        mode: "cors",
      }
    );

    const result = await response.json();

    if (result.status === "authenticationError") {
      window.location.href = "/login";
      return;
    }

    if (result.status === "success") {
      setMakeUserAdminStatusMessage(result.message);
    } else {
      setMakeUserAdminStatusMessage(result.message || "Failed to execute query");
    }
  } catch (error) {
    setMakeUserAdminStatusMessage(error.message);
  }
};